import { formatEventDate } from "@/service/format-event-date";
import { verboseDatetimeFormat } from "@/service/date/article";
import dayjs from "dayjs";
import { PulseLive } from "@/components/webinar/pulse-live";

export const WebinarMeta = ({
  start,
  end,
  title,
  isLive = false,
}: {
  start: string;
  end: string;
  title: string;
  isLive?: boolean;
}) => {
  const dateFormatted =
    dayjs(start).format("DD/MM/YYYY") !== dayjs(end).format("DD/MM/YYYY")
      ? formatEventDate(start, end, true)
      : `${verboseDatetimeFormat(start)} o ${dayjs(start).format("HH:mm")}`;

  return (
    <div className={"mt-3 flex items-center gap-10"}>
      {isLive ? (
        <PulseLive />
      ) : (
        <div className={"flex items-center gap-3"}>
          <div className={"text-muted-foreground text-sm font-medium"}>
            {dateFormatted}
          </div>
        </div>
      )}
    </div>
  );
};
